<div class="pt-100 unauth-container pb-50">
  <img src="/assets/images/Problem.svg">
  <div class="fw-500 fs-16 mat-subtitle-2 mt-16"> {{ 'UNAUTHORIZED.PROBLEM_MSG' | transloco }}</div>
  <div class="flex-row mt-16" dir="rtl">
    <button (click)="openContactForm()" class="accent ml-16" type="button">{{'BUTTONS.REPORT' | transloco}}</button>
    <button (click)="refreshPage()" class="white" type="button">{{'BUTTONS.REFRESH' | transloco}}</button>
  </div>
</div>